/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import * as XLSX from 'xlsx';

export const downloadExcel = (csvData: string): void => {
  if (!csvData?.trim()) return;

  try {
    const workbook = XLSX.read(csvData, {
      type: 'string',
      raw: true,
      cellText: true,
      cellDates: false,
    });

    const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { raw: true });
    if (!data.length) return;

    const newWorkbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
    const headers = Object.keys(data[0] as object);

    for (let row = 1; row < range.e.r + 1; row += 1) {
      headers.forEach((header, col) => {
        const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: col })] as XLSX.CellObject | undefined;
        if (!cell) return;

        const key = header.toLowerCase();

        if (key === 'age' && typeof cell.v === 'string') {
          try {
            const date = new Date(cell.v);
            if (!Number.isNaN(date.getTime())) {
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = String(date.getFullYear());
              cell.v = `${day}/${month}/${year}`;
              cell.t = 's'; // Set as string type
            }
          } catch (error) {
            console.warn('Date parsing failed for:', cell.v);
          }
        } else if (['numberOfScenes', 'aspectRatio', 'duration'].includes(key)) {
          cell.t = 's';
        } else if (typeof cell.v === 'string' && !Number.isNaN(Number(cell.v))) {
          cell.v = parseFloat(cell.v);
          cell.t = 'n';
        }

        if (key === 'spend') cell.z = '"$"#,##0.00';
        else if (['impressions', 'installs', 'clicks'].includes(key)) cell.z = '#,##0';
        else if (key === 'ipm') cell.z = '0.00';
        else if (['ctr', 'cti'].includes(key)) {
          if (typeof cell.v === 'number' && cell.v > 1) cell.v /= 100;
          cell.z = '0.00%';
        }
      });
    }

    XLSX.utils.book_append_sheet(newWorkbook, worksheet, 'Data');
    XLSX.writeFile(newWorkbook, 'export.xlsx');
  } catch (error) {
    console.error('Excel export failed:', error);
  }
};
